(function() {
  var wraps = document.querySelectorAll('[data-sbr-ra-slider-wrap]');
  wraps.forEach(function(wrap) {
    var grid    = wrap.querySelector('[data-sbr-ra-grid]');
    var prevBtn = wrap.querySelector('[data-sbr-ra-prev]');
    var nextBtn = wrap.querySelector('[data-sbr-ra-next]');
    if (!grid || !prevBtn || !nextBtn) return;

    function getCardWidth() {
      var card = grid.querySelector('.sbr-ra-card');
      if (!card) return 0;
      var style = getComputedStyle(grid);
      var gap   = parseFloat(style.gap) || 0;
      return card.offsetWidth + gap;
    }

    function updateButtons() {
      prevBtn.disabled = grid.scrollLeft <= 2;
      nextBtn.disabled = grid.scrollLeft + grid.offsetWidth >= grid.scrollWidth - 2;
    }

    prevBtn.addEventListener('click', function() {
      grid.scrollBy({ left: -getCardWidth() * 2, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function() {
      grid.scrollBy({ left: getCardWidth() * 2, behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });
})();
